import React, { useState, useEffect } from "react";
import BasicModal from 'src/components/Modal';
import MediaFrom from 'src/components/media/MediaFrom';
import AxiosInstance from "../Axios";
import { CButton, CFormInput, CFormLabel } from "@coreui/react";
import { confirmAlert } from "react-confirm-alert";
import ImagePreviewModal from "./ImagePreviewModal";
import { toast } from "react-toastify";

// Зроблений поки що тільки вівід фото.Модальне вікно закоментоване.Логіка зкопійована з компонента медіа і поки закоментована
const ProductMediaImgUrl = (props) => {
   // console.log('ProductMediaImgUrl props', props);
   // state для изменения части URL
   const [imgUrlPart, setImgUrlPart] = useState(
      props?.data?.imgUrl ? props.data.imgUrl : ""
   );

   const urlApi = "/products";
   const ApiParams = {
      "g[0]": "product:read",
      "g[1]": "product:admin",
      "g[3]": "product:category",
      "g[4]": "product:attributeItems",
      "g[5]": "product:media",
      "g[6]": "product:hover",
   };

   const [newMediaId, setNewMediaId] = useState(false);
   const [mediaIdForDelete, setMediaIdForDelete] = useState((props.myData?.mainMediaHover != undefined) ? props.myData.mainMediaHover.id : 0);
   const [media, setMedia] = useState((props.myData?.mainMediaHover != undefined) ? props.myData.mainMediaHover : "");
   // Для модального вікна "Додати зображення"
   const [showModalMedia, setShowModalMedia] = useState(true);
   //звичайна превью модалка
   const [previewOpen, setPreviewOpen] = useState(false);
   // Текст для popup
   const popupTextSuccess_1 = "Зображення додано";
   const popupTextSuccess_2 = "Зображення видалено";
   const popupTextError = "Помилка запиту";

   const imgSrc =
      props?.myData?.imgUrl
         ? `${process.env.REACT_APP_SERVER_URL}/${props.myData?.imgUrl}`
         : null;



   // Для модального вікна "Додати зображення"
   const actionShowModalMedia = (rez) => {
      setShowModalMedia(rez);
      // console.log('rez', rez);
      // if (!rez)
      // UpdateMedia();
   };

   const changeImgUrl = () => {
      if (!imgUrlPart) return;
      const send_data = {
         imgUrl: imgUrlPart
      }
      const response = AxiosInstance.put(`${urlApi}/${props.data.id}`, send_data,
         { params: ApiParams }
      ).then((response) => {
         console.log('products/id/ put response', response);
         if (response.status === 200) {
            // Popup про успішні зміни
            toast.success(popupTextSuccess_1);
            // props.setMyData(response.data);
            props.setMyData((prev) => ({
               ...prev,
               imgUrl: imgUrlPart
            }));
         }
      }).catch(e => {
         toast.error(popupTextError)
      });

   };



   return (
      <>
         <div className="d-flex my-3 flex-column" >
            <div>
               {
                  (props?.myData?.imgUrl) &&
                  <img className="me-3"
                     src={(props?.myData?.imgUrl != "" && props?.myData?.imgUrl !== undefined) ? `${process.env.REACT_APP_SERVER_URL}/${props?.myData?.imgUrl}` : ''}
                     style={{ height: "300px", cursor: 'pointer' }}
                     onClick={() => setPreviewOpen(true)}
                  />
               }
            </div>
            {(props?.data?.imgUrl) && <div>
               <ImagePreviewModal
                  open={previewOpen}
                  onClose={() => setPreviewOpen(false)}
                  src={imgSrc}
               />
            </div>}

            <div className="d-flex flex-column w-100">
               {/* Input для зміни  частини URL */}
               {/* <div className="col"> */}
               <div className="mb-3">
                  <CFormLabel htmlFor="img-url-input">Частина URL для зображення</CFormLabel>
                  <CFormInput
                     type="text"
                     id="img-url-input"
                     value={imgUrlPart}
                     onChange={(e) => setImgUrlPart(e.target.value)}
                     autoComplete="off"
                     className="w-50"
                  />
               </div>
               {/* </div> */}


               {/*  показати повний URL */}
               {/* <div className="mb-3">
                  <CFormLabel>Повний URL</CFormLabel>
                  <CFormInput type="text" value={imgSrc || ""} disabled className="w-100" />
               </div> */}
            </div>

            {/* КНОПКА */}
            <CButton
               color="primary"
               // className="w-50"
               style={{ width: '200px' }}
               disabled={
                  !imgUrlPart ||
                  imgUrlPart === props?.myData?.imgUrl}
               onClick={() => {
                  console.log("Новий imgUrl:", imgUrlPart);
                  changeImgUrl()
               }}
            >
               Змінити зображення
            </CButton>


         </div >
      </>
   );
};

export default ProductMediaImgUrl;